// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__3wEm4","info":"Note_info__2NUgY","note":"Note_note__2n0BF","actions":"Note_actions__20hVh"};